import React, { useContext, useEffect, useState } from 'react';
import "./style.scss"
import PropTypes from 'prop-types';
import { FlowDetailsContext } from '../../../../../../../../providers/flowDetails-provider';
import classNames from 'classnames';
import { amountFormatter } from '../../../../../../../../utils/index';

const Cards = () => {

    const { flowDetails, setCardData } = useContext(FlowDetailsContext);
    const [selectedCardIndex, setSelectedCardIndex] = useState(null);

    const handleCardData = (ele, index) => {
        setCardData(ele);
        setSelectedCardIndex(index);
    }

    useEffect(() => {
        if (flowDetails && flowDetails?.flowData?.flowDetails?.length) {
            setSelectedCardIndex(null);
        }
    }, [flowDetails]);


    return (
        <div className="cards-container">
            {
                flowDetails && flowDetails?.flowData && flowDetails?.flowData?.flowDetails?.length ? <>
                    <div className='cards-container__row'>
                        {flowDetails?.flowData?.flowDetails?.map((ele, i) => (i % 2 === 0) &&
                            <div key={i} className={classNames('cards-container__itemData', { 'cards-container__itemData__selected': selectedCardIndex === i })} onClick={() => handleCardData(ele, i)}>
                                <p>{ele.stepName}</p>
                                <div className='cards-container__itemData__data'>
                                    <p><span>#</span> {ele.totalApplications}</p>
                                    <p><span>₹</span> {amountFormatter(ele.amount)}</p>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='cards-container__row'>
                        {flowDetails?.flowData?.flowDetails?.map((ele, i) => (i % 2 !== 0) &&
                            <div key={i} className={classNames('cards-container__itemData', { 'cards-container__itemData__selected': selectedCardIndex === i })} onClick={() => handleCardData(ele, i)}>
                                <p>{ele.stepName}</p>
                                <div className='cards-container__itemData__data'>
                                    <p><span>#</span> {ele.totalApplications}</p>
                                    <p><span>₹</span> {amountFormatter(ele.amount)}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </> : null
            }
        </div>
    )
}

export default Cards;

Cards.propTypes = {
    cardData: PropTypes.array,
}
